import { createApp } from 'vue';
import App from './App.vue';
import { createI18n } from 'vue-i18n';

import router from './router.js';
import 'bootstrap/dist/css/bootstrap.css';
import '../public/assets/css/main.css';
import bootstrap from 'bootstrap/dist/js/bootstrap.min.js';

// Import your locale messages
import en from './locales/en.json';
import fr from './locales/fr.json';

// Set up the i18n instance
const i18n = createI18n({
  legacy: false,
  locale: 'en', // default language
  fallbackLocale: 'en',
  messages: { en, fr }
});

const app = createApp(App);

app.use(router);
app.use(bootstrap);
app.use(i18n); // Install i18n instance

app.mount('#app');
export { i18n };